export default __webpack_public_path__ + "static/media/Shield_Essex_Color_Rev_Stacked.16d42d18.png";